import ReactReconciler from 'react-reconciler';
import hostConfig from './hostConfig';
export var ReactReconcilerInst = ReactReconciler(hostConfig);
if (process.env.NODE_ENV === 'development') {
    ReactReconcilerInst.injectIntoDevTools({
        bundleType: 1,
        version: '16.13.1',
        rendererPackageName: 'remax',
    });
}
function getPublicRootInstance(container) {
    var containerFiber = container.current;
    if (!containerFiber.child) {
        return null;
    }
    return containerFiber.child.stateNode;
}
export default function render(rootElement, container) {
    // Create a root Container if it doesnt exist
    if (!container._rootContainer) {
        container._rootContainer = ReactReconcilerInst.createContainer(container, false, false);
    }
    ReactReconcilerInst.updateContainer(rootElement, container._rootContainer, null, function () {
        // ignore
    });
    return getPublicRootInstance(container._rootContainer);
}
